import { apiClient } from './client';

export const listTerminals = () => apiClient.get('/terminals').then((r) => r.data);
export const getTerminal = (id) => apiClient.get(`/terminals/${id}`).then((r) => r.data);
export const createTerminal = (data) => apiClient.post('/terminals', data).then((r) => r.data);
export const updateTerminal = (id, data) => apiClient.put(`/terminals/${id}`, data).then((r) => r.data);
export const deleteTerminal = (id) => apiClient.delete(`/terminals/${id}`);
export const deployTerminal = (id) => apiClient.post(`/terminals/${id}/deploy`).then((r) => r.data);
export const disableTerminal = (id) => apiClient.post(`/terminals/${id}/disable`).then((r) => r.data);
export const setTerminalAuth = (id, data) => apiClient.put(`/terminals/${id}/auth`, data).then((r) => r.data);
export const setTerminalSecret = (id, key, value) =>
  apiClient.put(`/terminals/${id}/secrets`, { key, value }).then((r) => r.data);
export const deleteTerminalSecret = (id, key) =>
  apiClient.delete(`/terminals/${id}/secrets/${encodeURIComponent(key)}`).then((r) => r.data);
export const getTerminalLogs = (id) => apiClient.get(`/terminals/${id}/logs`).then((r) => r.data.logs);
export const getAllowedModules = () =>
  apiClient.get('/terminals/meta/allowed-modules').then((r) => r.data.modules);
